var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wtw-container full-list-container" },
    _vm._l(_vm.options, function(option) {
      return _c(
        "div",
        {
          staticClass: "option button full-width outline",
          class: { active: _vm.optionActive(option.product_option_value_id) },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toggleOption(option.product_option_value_id)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "text-container",
              class: { "text-container-icon": _vm.optionImageExists(option) }
            },
            [
              _vm.optionImageExists(option)
                ? _c("span", {
                    staticClass: "icon",
                    style: _vm.iconStyle(option)
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(option.product_option_value_title))])
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6a4c360", { render: render, staticRenderFns: staticRenderFns })
  }
}